var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:_vm.color},[_c('div',{staticClass:"relative"},[_c('h1',[_vm._v(_vm._s(_vm.$env.APP_NAME))]),_c('h2',[_vm._v(_vm._s(_vm.subtitle))]),(_vm.button)?_c('div',{staticClass:"menu",on:{"click":_vm.menu}},[_c('img',{attrs:{"src":require("../assets/img/menu-expand.svg"),"alt":""}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }